import { ProductSearchRecordItemResponse } from '../../types/service-response'

export class ProductSearchRecord {
  public constructor (
    readonly id: number,
    readonly nummer: string | null,
    readonly barcode: string | null,
    readonly sortierung: string | null,
    readonly klassifizierung: string | null,
    readonly beschreibung: string | null,
    readonly bezeichnung: string | null,
    readonly gesperrt: boolean,
    readonly ersatz: number,
    readonly pGrp: string | null,
    readonly produktgruppe: string | null,
    readonly preview: string | null,
    readonly bevorzugt: boolean,
    readonly bestand: number,
    readonly bestellt: number,
    readonly reserviert: number,
    readonly verfuegbar: number,
    readonly einheit: number,
    readonly einheitCode: string | null,
    readonly einheitBezeichnung: string | null,
    readonly ertrag: number,
    readonly version: string | null,
    readonly bestandesfuehrung: boolean,
    readonly chargenpflicht: boolean,
    readonly retrogradeAbbuchung: boolean,
    readonly sammelartikel: boolean,
    readonly seriennummernfuehrung: boolean,
    readonly seriennummernpflicht: boolean,
    readonly ce: boolean,
    readonly sev: boolean,
    //To be connected to the SP
    readonly bemerkung: string | null,
    readonly invZaehlungen: number | null,
  ) {}

  static createFromResponse (item: ProductSearchRecordItemResponse): ProductSearchRecord {
    return new ProductSearchRecord(
      item.ID,
      item.Nummer,
      item.Barcode,
      item.Sortierung,
      item.Klassifizierung,
      item.Beschreibung,
      item.Bezeichnung,
      item.Gesperrt,
      item.Ersatz,
      item.PGrp,
      item.Produktgruppe,
      item.Preview,
      item.Bevorzugt,
      item.Bestand,
      item.Bestellt,
      item.Reserviert,
      item.Verfuegbar,
      item.Einheit,
      item.EinheitCode,
      item.EinheitBezeichnung,
      item.Ertrag,
      item.Version,
      item.Bestandesfuehrung,
      item.Chargenpflicht,
      item.RetrogradeAbbuchung,
      item.Sammelartikel,
      item.Seriennummernfuehrung,
      item.Seriennummernpflicht,
      item.CE,
      item.SEV,
      //To be connected to the SP
      item.Bemerkung,
      item.InvZaehlungen
    )
  }

  static createListFromResponse (responseData: ProductSearchRecordItemResponse[]): Array<ProductSearchRecord> {
    let result: Array<ProductSearchRecord> = []
    if (responseData) {
      result = responseData.map((item: ProductSearchRecordItemResponse) => {
        return new ProductSearchRecord(
          item.ID,
          item.Nummer,
          item.Barcode,
          item.Sortierung,
          item.Klassifizierung,
          item.Beschreibung,
          item.Bezeichnung,
          item.Gesperrt,
          item.Ersatz,
          item.PGrp,
          item.Produktgruppe,
          item.Preview,
          item.Bevorzugt,
          item.Bestand,
          item.Bestellt,
          item.Reserviert,
          item.Verfuegbar,
          item.Einheit,
          item.EinheitCode,
          item.EinheitBezeichnung,
          item.Ertrag,
          item.Version,
          item.Bestandesfuehrung,
          item.Chargenpflicht,
          item.RetrogradeAbbuchung,
          item.Sammelartikel,
          item.Seriennummernfuehrung,
          item.Seriennummernpflicht,
          item.CE,
          item.SEV,
          //To be connected to the SP
          item.Bemerkung,
          item.InvZaehlungen
        )
      })
    }
    return result
  }
}
